export const downloadCsv = (data, fileName = 'data') => {
  var hiddenElement = document.createElement('a');
  hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(data);
  hiddenElement.download = `${fileName}.csv`;
  hiddenElement.click();
};
